import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-choice-modal',
  templateUrl: './support-choice-modal.component.html',
  styleUrls: ['./support-choice-modal.component.scss']
})
export class SupportChoiceModalComponent implements OnInit {

  title: string = 'Send To';
  description: string = 'Please select where you would like to send your question/comment.';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  modalClose() {
    this.activeModal.close();
  }

  sendToTaxDoc() {
    this.activeModal.close(1);
  }

  sendToTechSupport() {
    this.activeModal.close(2);
  }
}
